import type { ReactNode } from 'react';
import styles from './DialogNotice.module.css';

interface DialogNoticeProps {
  children: ReactNode;
}

export function DialogNotice({ children }: DialogNoticeProps) {
  return (
    <div className={styles.notice}>
      <div className={styles.icon} aria-hidden="true">
        ⚠️
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
